export default __webpack_public_path__ + "static/hero-viitorul-d297fd53f02635023e5add7c81985ef0.jpg";